import { createSystemLogger, LogLevel, WarnerConfigs } from './logger';
import { sentryPlugin, createSentryPlugin } from './sentry';

declare global {
  interface Window {
    logger?: ReturnType<typeof createSystemLogger>;
  }
}

const defaultLoggerConfig: Omit<WarnerConfigs, 'plugins'> = {
  std: console,
  logLevel: () => {
    if (process.env.APP_ENV === 'production') {
      return LogLevel.ERROR;
    }
    return LogLevel.DEBUG;
  },
  prefix: 'Kamereo',
};

/**
 * Tạo logger với danh sách plugin tùy chỉnh
 * @param plugins Array các plugin để gắn vào logger
 * @returns Logger instance
 */
function createLoggerWithPlugins(plugins: any[]) {
  return createSystemLogger({
    ...defaultLoggerConfig,
    plugins: plugins,
  });
}

// Logger mặc định với Sentry plugin tiêu chuẩn
export const logger = createLoggerWithPlugins([sentryPlugin]);

/**
 * Tạo logger với plugin Sentry tùy chỉnh
 * @example
 * const customLogger = createLoggerWithSentry({
 *   enableTracing: true,
 *   defaultScope: { userId: 'user-123' }
 * });
 */
export function createLoggerWithSentry(sentryOptions = {}) {
  const customSentryPlugin = createSentryPlugin(sentryOptions);
  return createLoggerWithPlugins([customSentryPlugin]);
}

export function enableLogger() {
  if (typeof window !== 'undefined') {
    window.logger = logger;
    window.addEventListener('error', (e) => {
      logger.error('Unhandled error, resource fetched fail', e.error);
    });
  }
}
